@if (showToolbar) {
<div class="d-flex justify-content-end gap-2 mb-2">
  <button
    class="btn btn-outline-secondary"
    type="button"
    placement="top"
    [ngbTooltip]="'words.reloadTable' | translate"
    (click)="reloadDatatable()">
    <i class="fa fa-repeat"></i>
  </button>

  <shared-dropdown-report-export
    [module]="REPORT_MODULES"
    [currentFilters]="currentFilters"
    [currentLimit]="currentLimit"
    [currentPage]="currentPage"
    (exportRequested)="onReportExportRequested($event)"></shared-dropdown-report-export>
</div>
}

<shared-tables-ngx-datatable
  [config]="config$ | async"
  [data]="data$ | async"
  (onChangeLimit)="onChangeLimit($event)"
  (onChangePage)="onChangePage($event)">
</shared-tables-ngx-datatable>

<ng-template #bonusClaimDate let-row="row" let-rowIndex="rowIndex">
  <span class="text-end w-100">
    {{ row.bonusClaimDate | date: FORMAT_FOR_DATES_LONG }}
  </span>
</ng-template>

<ng-template #bonusCreationDate let-row="row" let-rowIndex="rowIndex">
  <span class="text-end w-100">
    {{ row.bonusCreationDate | date: FORMAT_FOR_DATES_LONG }}
  </span>
</ng-template>

<ng-template #expirationDate let-row="row" let-rowIndex="rowIndex">
  <span class="text-end w-100">
    {{ row.expirationDate | date: FORMAT_FOR_DATES_LONG }}
  </span>
</ng-template>

<ng-template #bonusActivationDate let-row="row" let-rowIndex="rowIndex">
  <span class="text-end w-100">
    {{ row.activationDate | date: FORMAT_FOR_DATES_LONG }}
  </span>
</ng-template>

<ng-template #bonusResultDate let-row="row" let-rowIndex="rowIndex">
  <span class="text-end w-100">
    {{ row.resultDate | date: FORMAT_FOR_DATES_LONG }}
  </span>
</ng-template>

<ng-template #bonusUpdateDate let-row="row" let-rowIndex="rowIndex">
  <span class="text-end w-100">
    {{ row.updatedAt | date: FORMAT_FOR_DATES_LONG }}
  </span>
</ng-template>

<ng-template #amount let-row="row" let-rowIndex="rowIndex">
  <span class="text-end w-100">
    {{ row.amount | number: '1.2-2' }}
  </span>
</ng-template>

<ng-template #amountDeposited let-row="row" let-rowIndex="rowIndex">
  <span class="text-end w-100">
    {{ row.amountDeposited || 0 | number: '1.2-2' }}
  </span>
</ng-template>

<ng-template #amountBonusGenerated let-row="row" let-rowIndex="rowIndex">
  <span class="text-end w-100">
    {{ row.amountBonusGenerated || 0 | number: '1.2-2' }}
  </span>
</ng-template>

<ng-template #amountBonusPaid let-row="row" let-rowIndex="rowIndex">
  <span class="text-end w-100">
    {{ row.amountBonusPaid || 0 | number: '1.2-2' }}
  </span>
</ng-template>

<ng-template #wasDeposit let-row="row" let-rowIndex="rowIndex">
  @if (!row.isTotalRow) {
    <div class="list-circle">
      <span class="item" [ngClass]="row.wasDeposit ? 'bg-success ' : 'bg-danger'"></span>
      <span>{{ row.wasDeposit | booleanToYesNo | translate }}</span>
    </div>
  }
</ng-template>

<ng-template #bonusState let-row="row" let-rowIndex="rowIndex">
  <span>{{ row?.state?.[lang.code.value] || '' }}</span>
</ng-template>

<ng-template #bonusResult let-row="row" let-rowIndex="rowIndex">
  <span>{{ row?.result?.[lang.code.value] || '' }}</span>
</ng-template>

<ng-template #actions let-row="row" let-rowIndex="rowIndex">
  @if (!row.isTotalRow) {
    <div class="d-flex align-items-center justify-content-center gap-2">
      <button
        *appShowWithPermission="PERMITTED_VIEWS.BTN_CANCEL_BONUS"
        class="btn btn-outline-secondary btn-xs"
        type="button"
        placement="left"
        [disabled]="row.wasUsed || row.isCancel === true"
        (click)="openModal(BUTTON_ACTIONS.CANCEL, row)"
        [ngbTooltip]="'btn.cancel' | translate">
        <i class="fa fa-ban"></i>
      </button>

      <button
        *appShowWithPermission="PERMITTED_VIEWS.BTN_VIEW_BONUS"
        class="btn btn-outline-secondary btn-xs"
        type="button"
        placement="left"
        (click)="openModalBonusReportInfo(BUTTON_ACTIONS.VIEW, row)"
        [ngbTooltip]="'btn.view' | translate">
        <i class="fa fa-eye"></i>
      </button>
    </div>
  }
</ng-template>
